import React, { useState, useEffect } from 'react';
import styles from './CookieConsent.module.scss';
import { CookieSettingsModal } from './CookieSettingsModal';

const CookieConsent: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const hasAccepted = localStorage.getItem('cookiesAccepted');
    if (!hasAccepted) {
      setIsVisible(true);
    }
  }, []);

  const handleAcceptAll = () => {
    localStorage.setItem('cookiesAccepted', 'true');
    setIsVisible(false);
  };

  const handleSavePreferences = () => {
    localStorage.setItem('cookiesAccepted', 'true');
    setIsVisible(false);
    setIsModalOpen(false);
  };

  if (!isVisible) return null;

  return (
    <>
      <div className={styles['cookie-consent']}>
        <div className={styles['cookie-consent__container']}>
          <div className={styles['cookie-consent__content']}>
            <p className={styles['cookie-consent__title']}>
              Сайт использует cookies
            </p>
            <button className={styles['cookie-consent__btn--customize']} onClick={() => setIsModalOpen(true)}>
              Настроить
            </button>
          </div>
          <div className={styles['cookie-consent__actions']}>
            <div className={styles['cookie-consent__accept-wrapper']}>
              <button className={styles['cookie-consent__btn--accept']} onClick={handleAcceptAll}>
                Принять все
              </button>
            </div>
          </div>
        </div>
      </div>

      <CookieSettingsModal 
        isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} onSave={handleSavePreferences}/>
    </>
  );
};

export { CookieConsent };